import BannerSkeleton from './PromoPageComponent/Banner/BannerSkeleton';
import logoWhite from './../assets/images/logo__white.svg';
import LanguageSwitcherSkeleton from '../i18n/components/LanguageSwitcher/LanguageSwitcherSkeleton';
import './HeaderSkeleton.scss';

const HeaderSkeleton = () => {

  return (
    <header className='header__skeleton'>
      <div className='header__logo__item__skeleton'>
        <div className='header__logo__link__skeleton'>
          <img className='logo' src={logoWhite} alt='Main-Logo-Design-Studio-Skeleton'/>
        </div>
      </div>
      <BannerSkeleton />
      <div className='header__burger__item__skeleton'>
        <div className="temp__skeleton">
          <span className="burger__skeleton"></span>
          <span className="burger__skeleton"></span>
          <span className="burger__skeleton"></span>
        </div>
      </div>
      <LanguageSwitcherSkeleton />
      <div className="sidebar__skeleton"></div>
    </header>
  );
};

export default HeaderSkeleton;